import styled from "styled-components";

export const WrapperFooter = styled.div`
    display: flex;
    justify-content: center;
    height: 100px;
    line-height: 100px;
    background-color: #ccc;
`